<template>
 <div class="c-student">
  <div class="c-student__head">
    <i class="head-icon"/>
    <p class="head-title">学生分布</p>
  </div>

  <div class="c-student__spread" v-if="spreadData.length">
    <div class="spread-left">
      <el-table
      ref="singleTable"
      :data="spreadData"
      :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
      highlight-current-row
      @cell-mouse-enter="enter"
      @cell-mouse-leave="leave"
      style="width: 100%">
        <el-table-column
          prop="level"
          label="掌握程度"
          align="center">
        </el-table-column>
        <el-table-column
          prop="stu_count"
          label="本班人数"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="spread-right">
      <div class="spread-right__header">
        学生（掌握程度）
      </div>
      <div class="spread-right__content" v-if="stuTotalList.length">
        <div class="content-item" v-for="(child, index) in stuTotalList"
        :key="`stu_${index}`">
          {{child.student_name}}：{{(child.avg_ability*100).toFixed(0)}}%
        </div>
      </div>
      <div class="student-empty" v-if="!stuTotalList.length">
        <img src="../images/empty.png" alt="">
        <p class="empty-text">暂无数据</p>
      </div>
    </div>
  </div>

  <div class="c-student__spread" v-else>
    <el-table
    ref="singleTable"
    :data="spreadData"
    :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
    style="width: 100%">
      <div slot="empty" class="no-data">
        <emptyContent/>
      </div>
      <el-table-column
        prop="level"
        label="掌握程度"
        align="center"
        width="200px">
      </el-table-column>
      <el-table-column
        prop="stu_count"
        label="本班人数"
        align="center"
        width="200px">
      </el-table-column>
        <el-table-column
        prop="stu_list"
        label="学生（掌握程度）"
        align="center">
      </el-table-column>
    </el-table>
  </div>

  <div class="c-student__head">
    <i class="head-icon"/>
    <p class="head-title">学生掌握明细</p>
    <div class="head-operate">
      <el-input v-model="searchName" clearable placeholder="请输入学生名称">
      </el-input>
      <el-button type="primary" @click="onSearchClick">查询</el-button>
    </div>
  </div>

  <section class="c-student__table">
    <el-table
      ref="multipleTable"
      :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
      :data="studentList"
      style="width: 100%;">
      <div slot="empty" class="no-data">
        <emptyContent/>
      </div>
      <el-table-column
        type="index"
        width="50"
        label="序号"
        align="center">
      </el-table-column>
      <el-table-column
        v-for="item in columnName"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :sortable="item.sortable"
        align="center"
      >
       <template slot-scope="scope">
          <template v-if="item.prop==='avg_ability'">
            <span :class="getRightClass(scope.row[item.prop])">
              {{scope.row[item.prop]===-1?'--':scope.row[item.prop]+'%'}}
            </span>
          </template>
          <template v-else-if="item.prop==='avg_cost_time'">
            <span>
              {{scope.row[item.prop]===-1?'--':secondToDate(scope.row[item.prop])}}
            </span>
          </template>
          <template v-else-if="item.prop==='right_rate'">
            <span>
              {{scope.row[item.prop]===-1?'--':scope.row[item.prop]+'%'}}
            </span>
          </template>
          <template v-else-if="item.prop==='topic_num'">
            <span>
              {{scope.row[item.prop]===-1?'--':scope.row[item.prop]}}
            </span>
          </template>
          <template v-else-if="item.prop==='low_score_count'">
            <span>
              {{scope.row[item.prop]===-1?'--':scope.row[item.prop]+'个'}}
            </span>
          </template>
          <template slot-scope="scope" v-else>
            {{scope.row[item.prop]}}
          </template>
       </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
             @click="queryStudentReport(scope.$index, scope.row)">
            <div :class="scope.row.tsid?'':'disable-color'">查看报告</div>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </section>
 </div>
</template>

<script>
import { openTab } from '@/utils';
import { getStudentScoreList } from '../../../api/pt';
import emptyContent from './empty-content.vue';

export default {
  name: 'StudentDetail',
  components: {
    emptyContent,
  },
  props: {
    studentData: {
      type: Array,
      default: () => [],
    },
    spreadData: {
      type: Array,
      default: () => [],
    },
    changeData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stuTotalList: [],
      searchName: '',
      columnName: [{
        label: '学生名称',
        prop: 'name',
        sortable: false,
      }, {
        label: '掌握程度',
        prop: 'avg_ability',
        sortable: true,
      },
      {
        label: '答题数',
        prop: 'topic_num',
        sortable: true,
      },
      {
        label: '正答率',
        prop: 'right_rate',
        sortable: true,
      }, {
        label: '测评用时',
        prop: 'avg_cost_time',
        sortable: true,
      }, {
        label: '未掌握知识点数',
        prop: 'low_score_count',
        sortable: true,
      }],
      studentList: [],
      timer: null,
      changeColumn: {},
    };
  },
  watch: {
    changeData(v) {
      this.changeColumn = v;
    },
    studentData(v) {
      this.studentList = v;
    },
    spreadData(v) {
      if (v.length) {
        this.$nextTick(() => {
          this.$refs.singleTable.setCurrentRow(v[0]);
          this.stuTotalList = v[0].stu_list.map((item) => item).sort((a, b) => (b.avg_ability * 100)
           - (a.avg_ability * 100));
        });
      }
    },
  },
  methods: {
    // hover离开后定位到离开hover的位置
    leave(row) {
      this.spreadData.forEach((item) => {
        if (item.level === row.level) {
          this.$refs.singleTable.setCurrentRow(item);
          this.stuTotalList = item.stu_list.map((child) => child).sort(
            (a, b) => b.avg_ability - a.avg_ability,
          );
        }
      });
    },
    // hover触发处理
    enter(row) {
      this.$refs.singleTable.setCurrentRow({});
      this.spreadData.forEach((item) => {
        if (item.level === row.level) {
          this.stuTotalList = item.stu_list.map((child) => child).sort(
            (a, b) => b.avg_ability - a.avg_ability,
          );
        }
      });
    },
    // 时分秒转化
    secondToDate(result) {
      const seconds = result % 60;
      const minutes = Math.floor(result / 60);
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
    onSearchClick() {
      // change后的值处理
      if (Object.keys(this.changeColumn).length) {
        this.getStudentScoreList(this.searchName, this.changeColumn);
        return;
      }
      this.getStudentScoreList(this.searchName, {});
    },
    // 正答率样式添加
    getRightClass(value) {
      if (value === -1) {
        return 'default';
      }
      if (value >= 70) {
        return 'level2';
      }
      if (value >= 40) {
        return 'level1';
      }
      return 'level3';
    },
    queryStudentReport(index, item) {
      const isProduction = !window.location.host.includes('dev');
      // 区分线上和测试环境
      const address = isProduction
        ? 'https://jzjx.classba.cn'
        : 'https://jzjx.test.classba.cn'; // 测试环境

      // 获取校区ID
      const { schoolId } = this.$route.query;
      if (item.tsid) {
        // 跳到报告页需要item.ts_id参数
        const url = `${address}/dl-web/question/report?id=${item.tsid}&schoolId=${schoolId}`;
        openTab(url);
      }
    },
    getStudentScoreList(value, data) {
      const { evaluateId, schoolId, classId } = this.$route.query;
      // console.log('ddd', data);
      return getStudentScoreList({
        evaluate_id: data.evaluate_id
          ? data.evaluate_id
          : evaluateId,
        school_id: schoolId,
        class_id: data.class_id
          ? data.class_id
          : classId,
        name: value,
      }).then((res) => {
        if (res.code === 200) {
          this.studentList = res.data.stu_list || [];
          // this.studentScoreList = res.data.score_distribution || [];
          this.$emit('change-data', this.studentList);
        }
      });
    },
  },

};
</script>

<style lang="scss" scoped>
.c-student{
  box-sizing: border-box;
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding-top:50px;
  &__spread{
    display: flex;
    padding:20px;
    .spread-left{
      width:28%;
    }
    .spread-right{
      width:72%;
      height:286px;
      border:1px solid #F0F2F5;
      background:#f5f7fa;
      &__header{
        height:47px;
        text-align:center;
        line-height:47px;
        background:#F0F2F5;
        color:rgb(144, 147, 153);
        font-weight: 600;
        font-size:14px;
        font-family: Arial, Helvetica, sans-serif;
      }
      &__content{
        font-size:14px;
        height:239px;
        color:#606266;
        overflow:auto;
        font-family: Arial, Helvetica, sans-serif;
        clear:both;
        .content-item{
          width: 20%;
          height: 47px;
          line-height: 47px;
          text-align: center;
          float: left;
        }
      }
    }
  }
  &__head{
    padding-left:19px;
    position: relative;
    .head-icon{
      display: block;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
    }
    .head-title{
      position: absolute;
      top:5px;
      left:34px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
    .head-operate{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding:25px;
      .el-button {
        border-radius: 0 4px 4px 0;
      }
      .el-input {
        width: 243px;
        vertical-align: bottom;
        /deep/ .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
    }
  }
  &__table{
    padding:0 20px;
    .disable-color{
      color:#909399
    }
  }
}

/deep/ .el-table__body tr.current-row>td {
  background-color: #f5f7fa;
}

.no-data{
  line-height: 1.8;
  padding: 30px 0;
}

 .student-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #C0C4CC;
    font-size: 16px;
    img {
      width: 200px;
      margin-top: 35px;
    }
    .empty-text {
      color: rgba(0,0,0,0.6);
    }
  }
</style>
